import jQuery from 'jquery';
import slick from 'slick-carousel';

class HeroSlider {
    constructor(container) {
        this.$container = jQuery(container);
    }

    init() {
        const navContainer = this.$container.parent().find('.slider-nav');
        const dotsContainer = this.$container.parent().find('.slider-dots');

        this.$container.slick({
            appendArrows: navContainer,
            appendDots: dotsContainer,
            dots: true,
        });
    }
}


export { HeroSlider };
